import { DISPATCH_KINDS } from "@nexseed/shared";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { dispatchCalls } from "@/features/sales-dispatch/api";
import { errMsg } from "@/features/sales-dispatch/components/common";
import { DispatchPage } from "@/features/sales-dispatch/components/dispatch-page";

export const Route = createFileRoute("/_app/dispatch/sales/$kind/$id")({
  params: {
    parse: (p) => ({ kind: z.enum(DISPATCH_KINDS).parse(p.kind), id: p.id }),
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { kind, id } = Route.useParams();
  const d = useQuery({
    queryKey: ["sales-dispatch", kind, "detail", Number(id)],
    queryFn: () => dispatchCalls.get(kind, Number(id)),
  });
  if (d.isPending) return <FormPageSkeleton />;
  if (d.isError)
    return (
      <Callout tone="danger" title="Could not open this dispatch">
        {errMsg(d.error)}
      </Callout>
    );
  return (
    <DispatchPage
      key={`${d.data.id}-${d.data.status}`}
      kind={kind}
      dispatch={d.data}
      facilityId={d.data.facilityId}
    />
  );
}
